// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".nk-menu-item.active > .nk-menu-link {\n  background: #1a1e24;\n  opacity: 1;\n}\n", "",{"version":3,"sources":["webpack://./src/layout/default/Sidebar/menu-custom.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,UAAU;AACZ","sourcesContent":[".nk-menu-item.active > .nk-menu-link {\n  background: #1a1e24;\n  opacity: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
